<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a v-if="!localId" class="section" v-on:click="goTo('/local/users')">Usuarios</a>
    <a v-if="localId" class="section" v-on:click="goTo('/local/'+localId+'/users')">Usuarios</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Editar Usuario</a>
  </div>
  <h1 class="ui header"><i class="icon user"></i>
    <div v-if="role === 'localAdmin'" class="content">Editar Usuario Administrador</div>
    <div v-if="role === 'localUser'" class="content">Editar Usuario</div>
    <div v-if="role === 'master' || role === 'admin'" class="content">Editar Usuario</div>
  </h1>
  <button v-if="!id" class="ui basic button rightButton" v-on:click="goTo('/users', 'LocalUsers')">
    <i class="long arrow alternate left icon"></i>Atras
  </button>
  <div v-if="!userInfo" class="ui active centered inline loader"></div>
  <div v-if="userInfo" class="ui stackable two column divided grid container">
    <div class="row">
      <div class="column">
        <form class="ui form" @submit.prevent="saveUser">
          <h4 class="ui dividing header">Información del usuario</h4>
          <div class="inline field">
            <sui-checkbox label="Activo" toggle v-model="userInfo.LocalUser.active" />
          </div>
          <div class="field">
            <label>Nombre *</label>
            <input type="text" v-model="userInfo.LocalUser.name" placeholder="Nombre" required>
          </div>
          <div class="field">
            <label>Teléfono</label>
            <input type="text" v-model="userInfo.LocalUser.phone" placeholder="Teléfono" required>
          </div>
          <div class="field">
            <label>Email *</label>
            <input type="text" v-model="userInfo.LocalUser.email" placeholder="Email" pattern="^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$">
          </div>
          <div v-if="role === 'master' || role === 'admin'" class="field">
            <label>Role</label>
            <input type="text" v-model="userInfo.Administrator.role" readonly>
          </div>
          <div class="two fields">
            <div class="field">
              <label>Creado</label>
              <input type="text" v-model="userInfo.LocalUser.created" readonly>
            </div>
            <div class="field">
              <label>Modificado</label>
              <input type="text" v-model="userInfo.LocalUser.modified" readonly>
            </div>
          </div>
          <div class="field">
            <label>* Campos obligatorios</label>
          </div>
          <button id="save" class="ui button" type="submit">Guardar</button>
          <!--<div id="cancel" class="ui button eskubian" v-on:click="goTo('/local/users', 'LocalUsers')">Cancelar</div>-->
          <div class="ui button eskubian" v-on:click="cancelAction()">Cancelar</div>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'localUserInfo',
  props: ['id','theUserInfo','localId'],
  data() {
    return {
      userInfo: null,
      saving: false,
      role: null
    }
  },
  created(){
    //let role = JSON.parse(localStorage.admin).role
    this.role = JSON.parse(localStorage.admin).role
    if (this.role !== 'master' && this.role !=='localAdmin') {
      this.goTo('/parcels', 'localParcels');
    }

    if (!this.theUserInfo) {
      this.getUserInfo();
    } else {
      this.userInfo = this.theUserInfo;
    }
  },
  methods: {
    getUserInfo() {
      hapiickApi().post('/v2/locals/users/get-local-user', {
        admin_id: JSON.parse(localStorage.admin).id,
        userId: this.id,
        localId: this.localId
      })
      .then(request => {
        this.updateEditUser(request)
      })
      .catch(() => console.log('error getting user'))
    },
    saveUser() {
      this.saving = true
      //deshabilitar botones
      //document.getElementById('save').disabled = true;
      //document.getElementById('cancel').classList.add("disabled");

      hapiickApi().post('/v2/locals/users/edit', {
        admin_id: JSON.parse(localStorage.admin).id,
        userData: this.userInfo,
      })
      .then(request => this.userSaved(request))
      .catch(() => this.$swal({
        type: 'error',
        title: 'Error',
        text: 'No se han podido guardar los datos'
      }))
    },
    goTo(where, id) {
      let elems = document.getElementsByClassName('item')
      for (var i = 0; i < elems.length; i++) {
        elems[i].classList.remove('active');
      }
      this.$router.push(where)
      //document.getElementById(id).classList.add("active") //Si descomento esto sale msg de errorrr aunque se haya editado ok el usuario!!!!!!
    },
    updateEditUser(req) {
      let user = JSON.parse(JSON.stringify(req.data.user))
      //this.userInfo = user.LocalUser
      this.userInfo = user
    },
    userSaved(req) {
      this.saving = false;
      let msg = '';
      if (req.data.status !== 'OK') {
        if (req.data.status === 'KO') {
          msg = req.data.message;
        } else {
          msg = 'No se han podido guardar los datos';
        }        
        this.$swal({
          type: 'error',
          title: 'Error',
          text: msg
        })
      } else {
        this.$swal({
          type: 'success',
          title: 'Los datos se han guardado correctamente',
          showConfirmButton: false,
          timer: 2500
        })
        this.selectedUser = null

        this.cancelAction();
      }
    },
    disableButton(id) {
      let x = document.getElementById(id);
      x.disabled = true;
    },
    cancelAction() {
      if(this.role === 'master' || this.role === 'admin'){
        this.goTo('/local/'+this.localId+'/users', 'localUsers')
      } else {
        this.goTo('/local/users', 'localUsers')
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Local/localUserInfo.vue